import { configureStore } from '@reduxjs/toolkit';
import ctSlice from '../features/ctdata/ctSlice';
import pagSlice from '../features/ctdata/pagSlice';

export default configureStore({
  reducer:{ esc: ctSlice, pag: pagSlice }
});